export const paginator = {
  navButton: {
    selectedColor: '#ffffff',
    selectedBackground: '{primary.400}',
    borderRadius: '{border-radius}',
  },
  colorScheme: {
    light: {
      background: '{surface.100}',
      borderColor: '{primary.400}',
      color: '{text-color}',
      currentPageReportColor: '{text-color}',
      navButton: {
        color: 'black',
        hoverColor: '{neutral.500}',
        hoverBackground: '{primary.100}',
      },
    },
    dark: {
      background: '#3C434F',
      borderColor: '{primary.400}',
      currentPageReportColor: '#aeb5b7',
      color: '#aeb5b7',
      navButton: {
        color: '#ffffff',
        hoverColor: '{neutral.50}',
        hoverBackground: '{primary.200}',
      },
    },
  },
};
